export function resetReportData(state, payload) {
  return {
    data: state.baseline,
    dirty: true,
  };
}
